// Libraries
import { Padding, VictoryLabelStyleObject } from 'victory';
// Types
import { BarChartStyles } from './BarChart.types';
// Utils
import { colors } from '@themeFoundations/colors';

/**
 * Base styles for the chart label titles in x.
 */
const baseLabelStyle: VictoryLabelStyleObject = {
  fontSize: 14,
  fill: colors.text.faded,
};

/**
 * Base styles for the chart padding.
 */
const baseChartPadding: Padding = {
  bottom: 40,
  left: 30,
  right: 30,
  top: 20,
};

/**
 * Responsiveness values fot the chart labels and padding.
 */
export const barChartStylesMap: BarChartStyles = {
  labelStyle: {
    base: {
      ...baseLabelStyle,
    },
    sm: {
      ...baseLabelStyle,
      fontSize: 10,
      letterSpacing: 0,
    },
    '2xl': {
      ...baseLabelStyle,
      fontSize: 7,
    },
  },
  chartPadding: {
    base: {
      ...baseChartPadding,
    },
    md: {
      ...baseChartPadding,
      bottom: 20,
    },
  },
};
